/*=========================================================================================
  File Name: moduleProjectManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/project/pixinvent
==========================================================================================*/


import state from './moduleProjectManagementState.js'
import mutations from './moduleProjectManagementMutations.js'
import actions from './moduleProjectManagementActions.js'
import getters from './moduleProjectManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

